// PromoModalContent.js with centered button
import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  styled
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(4),
  borderRadius: '8px',
  outline: 'none',         // Remove default outline

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  }
}));

// For the ContentBox
const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  outline: 'none',         // Remove default outline

  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  }
}));

// Updated ButtonContainer to center the button
const ButtonContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(3),
  display: 'flex',
  justifyContent: 'center', // Changed from 'space-between' to 'center'

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'center', // Added to center in column direction on mobile
    gap: theme.spacing(2),

    '& .MuiButton-root': {
      width: '100%', // Full width on mobile
      maxWidth: '300px' // Optional: limit maximum width for better appearance
    }
  }
}));

const PromoModalContent = ({ onClose, onSignUp }) => {
  const { t } = useTranslation();

  return (
    <StyledPaper>
      <ContentBox>
        <Typography
          variant="h5"
          component="h2"
          id="tbreak-promo-modal-title"
          gutterBottom
          align="center"
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '1.4rem', sm: '1.5rem' },
            marginBottom: '1rem'
          }}
        >
          Welcome to HiveSpace!🐝✨
        </Typography>

        <Typography
          id="tbreak-promo-modal-description"
          paragraph
          sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}
        >
          We're thrilled to have you here! By joining below, your account will be linked to <strong>MeetUp - Work With Friends</strong>, giving you access to exclusive prices—like our <strong>co-working day on the 28th at The Workers League - Bonhill.</strong>
        </Typography>

        <Typography
          paragraph
          sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}
        >
          Our full community features are coming soon, and we'll shift communications here from MeetUp once they're live. 😊
        </Typography>

        <Typography
          paragraph
          sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}
        >
          For now, just join below, select <strong>the 28th on the calendar</strong>, and book a <strong>Hot Desk</strong>—we'll handle the rest!
        </Typography>
        <Typography
          paragraph
          sx={{ fontSize: { xs: '0.95rem', sm: '1rem' } }}
        >
          Have feedback? Hit the <strong>Feedback</strong> button or email us at <strong>hello@hivespace.co</strong>—we'd love to hear from you!
        </Typography>
        <Typography
          paragraph
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: '0.95rem', sm: '1rem' },
            color: 'primary.main'
          }}
        >
          Let's make work more social! 🚀
        </Typography>

        <ButtonContainer>
          <Button
            variant="contained"
            color="primary"
            onClick={onSignUp}
            size="large"
            sx={{ 
              px: 4, // Add more horizontal padding
              py: 1, // Add more vertical padding
              fontWeight: 'bold' // Make text bold for emphasis
            }}
          >
            Join community
          </Button>
        </ButtonContainer>
      </ContentBox>
    </StyledPaper>
  );
};

export default PromoModalContent;